module.exports = __webpack_public_path__ + "static/media/grab_singha600-1.e5221f2b.jpg";